import UploadCustomer  from  './Upload'

export default UploadCustomer